import { motion } from "framer-motion";
import { MapPin, Navigation, Dog } from "lucide-react";
import { LOCATION, PET_NOTE, IMAGES } from "@/data/content";

export const Location = () => {
  return (
    <section
      id="lokalizacja"
      data-testid="location-section"
      className="bg-[#F9F7F3] py-20 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 md:px-10 lg:grid-cols-2 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#4A7055]">
            {LOCATION.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-[#2D3728] text-balance md:text-4xl lg:text-5xl">
            {LOCATION.title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#4A5D43] md:text-lg">
            {LOCATION.description}
          </p>

          <div className="mt-8 space-y-3">
            {LOCATION.points.map((p) => (
              <div
                key={p.place}
                data-testid={`location-point-${p.place}`}
                className="flex items-center justify-between rounded-2xl border border-[#E4DDCF] bg-white px-5 py-4"
              >
                <div className="flex items-center gap-3">
                  <MapPin className="h-5 w-5 flex-shrink-0 text-[#9C5E4B]" />
                  <span className="text-sm font-medium text-[#2D3728]">
                    {p.place}
                  </span>
                </div>
                <span className="flex items-center gap-1.5 text-sm font-semibold text-[#4A7055]">
                  <Navigation className="h-3.5 w-3.5" /> {p.distance}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-6 flex items-start gap-3 rounded-2xl bg-[#EAE4D9] p-5">
            <Dog className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#9C5E4B]" />
            <p className="text-sm leading-relaxed text-[#4A5D43]">{PET_NOTE}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-[2rem]">
            <img
              src={IMAGES.kayakSunset}
              alt="Kajak na jeziorze o zachodzie słońca"
              className="h-[420px] w-full object-cover md:h-[540px]"
            />
          </div>
          <div className="absolute bottom-6 left-6 right-6 rounded-2xl border border-white/20 bg-[#2D3728]/85 p-5 backdrop-blur-md">
            <p className="font-display text-lg font-semibold text-white">
              Jezioro Juno, Mrągowo
            </p>
            <p className="mt-1 text-sm text-white/75">
              Serce Mazur — 25 minut do Mikołajek, 5 minut do centrum.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
